<template>
  <div class="leaderboard-title">答题排行榜</div>
  <Tabs class="tab-wrap" color="#3793FF">
    <Tab title="个人排名"
      ><ul class="leaderboard-list">
        <template v-if="rankList && rankList.length > 0">
          <li
            v-for="(item, index) in rankList"
            :key="item.customerId + index"
            class="list-item"
          >
            <div class="left">
              <div class="index">{{ index + 1 }}</div>
              <div class="img">
                <img :src="item.headImg" alt="" />
              </div>
              <div class="info">
                <!-- 德州临时处理显示姓名 -->
                <p v-if="store.getters.getOrgId !== '179'" class="name">
                  {{ item?.nickName }}
                </p>
                <p v-else class="name">{{ item?.name || item?.nickName }}</p>
                <p class="more">总用时：{{ formatLongTime(item.longTime) }}</p>
              </div>
            </div>
            <div class="right">{{ item?.sumScore || 0 }}分</div>
          </li>
        </template>
        <p class="no-data" v-else>
          暂无数据
        </p>
      </ul></Tab
    >
    <Tab v-if="showRankList" :title="rankListName"
      ><ul class="leaderboard-list">
        <template v-if="unitRankList && unitRankList.length > 0">
          <li
            v-for="(item, index) in unitRankList"
            :key="item.unitId"
            class="list-item"
          >
            <div class="left">
              <div class="index">{{ index + 1 }}</div>
              <div class="info">
                <p class="name">{{ item.unitName || item.name }}</p>
                <p class="more">总用时: {{ formatLongTime(item.totalTime) }}</p>
              </div>
            </div>
            <div class="right">总分：{{ item?.totalScore || '--' }}分</div>
          </li>
        </template>
        <p class="no-data" v-else>
          暂无数据
        </p>
      </ul></Tab
    >
  </Tabs>
</template>

<script>
import { Tab, Tabs } from 'vant'
import { getRankByQues, getRankByActivity } from '@/api/index'
import { getUnitRank } from '@/api/person'
import { useStore } from 'vuex'
import { getQueryString, formatDuring } from '@/utils/tools'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { computed } from '@vue/reactivity'

export default {
  components: {
    Tab,
    Tabs
  },
  setup() {
    const { rankList } = usePersonRankListEffect()

    const { unitRankList, rankListName, showRankList } = useUnitRankListEffect()

    const { formatLongTime } = useFormatEffect()

    const store = useStore()

    return {
      store,
      rankList,
      unitRankList,
      showRankList,
      rankListName,
      formatLongTime
    }
  }
}

// 获取个人排名列表
const usePersonRankListEffect = () => {
  const store = useStore()
  const rankList = ref([])
  const pageSize = store.getters.getQuesSetting?.rankNum
    ? store.getters.getQuesSetting?.rankNum
    : 10
  const pageNo = 1

  const getList = async () => {
    const res = await getRankByQues({
      pageSize,
      pageNo,
      orders: 1,
      questionActiveKey: getQueryString('questionActiveKey'),
      token: store.getters.getToken
    })

    if (res.ok) {
      rankList.value = [...res.data.rows]
    }
  }

  getList()

  return {
    rankList
  }
}

// 获取单位排名列表
const useUnitRankListEffect = () => {
  const store = useStore()
  const unitRankList = ref([])
  const pageSize = store.getters.getQuesSetting?.rankNum
    ? store.getters.getQuesSetting?.rankNum
    : 10
  const offset = 1

  const route = useRoute()

  // 存在活动id 或者 绑定了模板信息的时候展示单位排名
  const showRankList = computed(() => {
    if (route.query.questionActiveKey === 'c47cdc4800f5449b8b201af9c117489e') {
      return false
    }
    return route.query.activeId || store.getters.getQuesInfo.moduleId
  })

  const rankListName = computed(() => {
    return store.getters.getModuleInfo?.typeName || '单位排名'
  })

  let func
  const param = {
    questionActiveKey: getQueryString('questionActiveKey'),
    token: store.getters.getToken,
    pageSize,
    offset
  }

  if (route.query.activeId) {
    func = getRankByActivity
    param.activeId = route.query.activeId
  }
  if (store.getters.getQuesInfo.moduleId) {
    func = getUnitRank
    param.typeId = store.getters.getModuleInfo.typeId
  }

  const getList = async () => {
    const res = await func(param)

    if (res.ok) {
      unitRankList.value = [...res.data.rows]
    }
  }

  if (func) {
    getList()
  }

  return {
    unitRankList,
    rankListName,
    showRankList
  }
}

// 获取个人单位排名
const usePersonUnitRankListEffect = () => {
  const store = useStore()
  const unitRankList = ref([])
  const pageSize = store.getters.getQuesSetting?.rankNum
    ? store.getters.getQuesSetting?.rankNum
    : 10
  const offset = 1

  const getUnitRank = async () => {
    const res = await getRankByActivity({
      pageSize,
      offset,
      typeId: store.getters.getQuesInfo.moduleId,
      questionActiveKey: getQueryString('questionActiveKey'),
      token: store.getters.getToken
    })

    if (res.ok) {
      unitRankList.value = [...res.data.rows]
    }
  }

  getUnitRank()

  return {
    unitRankList
  }
}

// 设置过滤器
const useFormatEffect = () => {
  // 格式化时长
  const formatLongTime = str => {
    return str ? formatDuring(str) : '--'
  }

  return {
    formatLongTime
  }
}
</script>

<style lang="scss" scoped>
// 排行榜
.leaderboard-title {
  margin: 0 auto;
  width: 422px;
  height: 99px;
  line-height: 99px;
  background: no-repeat center/100% url('../../../assets/img/leaderBoard.png');
  color: #fff;
  font-size: 36px;
  text-align: center;
}
.tab-wrap {
  padding: 40px 0;
}
.no-data {
  margin: 20px 0;
  font-size: 32px;
  text-align: center;
}
.leaderboard-list {
  margin-left: 39px;
  margin-right: 49px;
  margin-top: 40px;
  padding-bottom: 20px;
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    height: 148px;
    padding: 42px 0 39px 0;
    border-bottom: 1px solid rgba(0, 130, 251, 0.2);

    .left {
      display: flex;
      align-items: center;
      height: 100%;
      .index {
        font-size: 36px;
        color: #2897ff;
      }
      .img {
        margin-left: 40px;
        width: 75px;
        height: 75px;
        border-radius: 50%;
        background-color: #ccc;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info {
        margin-left: 41px;
        p {
          margin: 0;
        }
        .name {
          margin-bottom: 14px;
          font-size: 34px;
          font-weight: 400;
          color: #333333;
        }
        .more {
          font-size: 26px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .right {
      font-size: 36px;
      font-weight: 400;
      color: #1382ff;
    }
  }
}
</style>
